export default {
  token: null,
  user: null,
  authToken: null,
  authUser: null,
  email: null,
  authExpiry: Date.now(), // firebase token expires after 1 hour
  error: null,
  success: null,
  currentUserGroups: null,
  isProviderUser: null,
  signature: null,
  brandingPartner: null
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js